import { Component, OnInit, OnDestroy, Input, Directive } from '@angular/core';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export class BaseViewComponent implements OnInit, OnDestroy{
	
	protected _unsubscribeAll: Subject<void>;

	constructor(
		public datasetACS: DatasetActionContainerService,
		protected datasetNavigatorService: DatasetNavigatorService
	){
		this._unsubscribeAll = new Subject<any>();
	}

	ngOnInit(): void{}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
